<template>
  <el-breadcrumb :separator-icon="ArrowRight" style="margin-bottom: 24px;">
    <template v-for="(item, index) in breadcrumbList" :key="index">
      <el-breadcrumb-item :to="{ path: item.path }" v-if="item.path">{{item.label}}</el-breadcrumb-item>
      <el-breadcrumb-item v-else>{{item.label}}</el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>

<script setup>
import {ref, watch} from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import {onMounted} from "vue";
const route = useRoute()

const breadcrumbList = ref([])
const breadcrumbMap = {
  settings: [
    { label: '首页', path: '/' },
    { label: '系统设置' }
  ],
  // banner: [
  //   { label: '首页', path: '/' },
  //   { label: '广告位列表' },
  // ],
  commodity: [
    { label: '首页', path: '/' },
    { label: '商品列表' },
  ],
  agency: [
    { label: '首页', path: '/' },
    { label: '分销员列表' },
  ],
  application: [
    { label: '首页', path: '/' },
    { label: '提现申请列表' },
  ],
  wallet: [
    { label: '首页', path: '/' },
    { label: '钱包列表' },
  ],
  order: [
    { label: '首页', path: '/' },
    { label: '订单列表' },
  ],
  user: [
    { label: '首页', path: '/' },
    { label: '用户列表' },
  ],
  admin: [
    { label: '首页', path: '/' },
    { label: '管理员列表' },
  ],
}
const init = () => {
  breadcrumbList.value = breadcrumbMap[route.name || '']
}
onMounted(() => {
  init()
})
watch(() => route.name, () => {
  init()
})

</script>

<style scoped lang="less">
  @import "index.less";
</style>
